<template>
  <RF-Dialog v-if="statusGeral !== null"
    :cpntLargura='"400px"'
    :cpntStatus="statusGeral"

    :cpntAbaVet="abaVet"
    :cpntAbaValue="abaVal"
    :cpntAbaOnChange="demNovaOnChangeAba"
    :cpntOnFecharDialog='demNovaFechar'>
    <template slot='titulo'>      
      <div class="dem-nova-titulo">
        <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
        Iniciar uma nova {{ cpntDemanda }} com:
      </div>
    </template>

    <template slot='conteudo'>
      <div class="dem-nova">
        <!-- SETA O SELECT DO CONTROLE DE PROCESSOS -->
        <App-Select :data-time="time" class="dem-nova--pco" v-if="cpntDemanda === 'venda' && $store.state.pcoAntigo === false && $store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 11 ], null, null, null, null, null, false) === true"
          :cpntStatus='campos.pco.status'
          :cpntId='campos.pco.id'
          :cpntNome='campos.pco.nome'
          :cpntValue='campos.pco.value'
          :cpntOptions='campos.pco.options'
          :cpntKeyValue='campos.pco.keyValue'
          :cpntKeyMostra='campos.pco.keyMostra'
          :cpntAutoComplete='campos.pco.autocomplete'
          :cpntDisabled='campos.pco.disabled'
          :cpntMostrar='campos.pco.mostrar'
          :cpntMensagem='campos.pco.mensagem'
          :cpntSelecioneNome='campos.pco.selecioneNome'
          :cpntSelecioneValue='campos.pco.selecioneValue'
          :cpntMensagemTipo='campos.pco.mensagemTipo'
          :cpntAdicinarOption='campos.pco.adicinarOption'
          :cpntMultiple='campos.pco.multiple'
          :cpntSearchMinimo='campos.pco.searchMinimo'

          :cpntOnChange='campos.pco.onChange'
          :cpntOnKeyPressEnter='campos.pco.onKeyPressEnter'
          :cpntOnFieldBlur='campos.pco.onBlur'
          ref="pco"
        ></App-Select>

        <!-- SETA O CAMPO DE BUSCA -->
        <App-Autocompletar :data-time="time" :class="campos.busca.id"
          :cpntStatus='campos.busca.status'
          :cpntId='campos.busca.id'
          :cpntTabIndex='campos.busca.tabIndex'
          :cpntNome='campos.busca.nome'
          :cpntValue='campos.busca.value'
          :cpntMensagem='campos.busca.mensagem'
          :cpntMensagemTipo='campos.busca.mensagemTipo'
          :cpntDisabled='campos.busca.disabled'
          :cpntMostrar='campos.busca.mostrar === true'
          :cpntExplica='campos.busca.explica'
          :cpntPlaceholder='campos.busca.placeholder'
          :cpntValueRef='campos.busca.valueRef'
          :cpntRouter='campos.busca.router'
          :cpntMethod='campos.busca.method'
          :cpntField='campos.busca.field'
          :cpntWhere='campos.busca.where'
          :cpntAddButForm='campos.busca.addButForm'
          :cpntKeyMostra='campos.busca.keyMostra'
          :cpntTipoOrder='campos.busca.tipoOrder'
          :cpntOrder='campos.busca.order'
          :cpntOptions='campos.busca.options'
          :cpntKeyValue='campos.busca.keyValue'
          :cpntSearchMinimo='campos.busca.searchMinimo'
          :cpntMask='campos.busca.mask'
          :cpntNewOption='campos.busca.newOption'

          :cpntOnBuscarOptions='campos.busca.onBuscarOptions'
          :cpntOnChange='campos.busca.onChange'
          :cpntOnBlur='campos.busca.onBlur'
          :cpntOnRealizaBusca='campos.busca.onRealizaBusca'
          :cpntOnKeyPressEnter='campos.busca.onKeyPressEnter'
          ref="busca"
        ></App-Autocompletar>

        <!-- COLOCA O BOTÃO PARA CRIAR A VENDA -->
        <div>
          <RF-Button :data-time='time'
          :cpntStatus='campos.botao.status' 
          :cpntId='campos.botao.id' 
          :cpntTexto='campos.botao.texto' 
          :cpntClass='campos.botao.class'
          :cpntMostrar='campos.botao.mostrar'
          :cpntDisabled="demNovaDisativarBotao()"
          :cpntTabIndex='campos.botao.tabIndex'
          @onClickButton='campos.botao.onClick'
        ></RF-Button>
        </div>
      </div>
    </template>
  </RF-Dialog>
</template>

<style scoped>
  .dem-nova-titulo {
    margin-top: 0px;
    margin-bottom: -5px;
  }
  .dem-nova {
    width: 90%;
    margin: 0px auto;
    text-align: center;
    padding-top: 20px;
  }
    .dem-nova > div {
      width: 100%;
    }
    .dem-nova > div:not(:first-child) {
      margin-top: 25px;
    }
    .dem-nova > button {
      width: 130px;
      margin-top: -15px;
      margin-bottom: 5px;
      padding: 5px;
    }
</style>

<style>
  .dem-nova > .cpnt-app-autocompletar > .com-new-option ~ button {
    opacity: 1 !important;
  }
</style>

<script>
  export default {
    props: {
      cpntDemanda: {
        required: true,
        type: String
      },
      cpntTipo: {
        required: false,
        type: String,
        default: function () {
          return 'contato'
        }
      },
      cpntParamsId: {
        required: false,
        type: Number
      },
      cpntRedirecionar: {
        type: Boolean,
        required: false,
        default: function () {
          return true
        }
      },
      cpntFecharFormulario: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    data: function () {
      return {
        time: '',
        statusGeral: null,
        abaVet: {},
        abaVal: '',
        campos: {
          pco: {
            id: 'dem-nova--pco',
            status: '',
            nome: 'Controle de processo',
            keyValue: 'id',
            keyMostra: [ 'nome' ],
            options: [],
            optionInicialNome: 'Não utilizar',
            mostrar: true,
            disabled: false,
            apiEnv: 'id_pco_status',
            mensagem: '',
            mensagemTipo: '',
            onChange: this.demNovaCamposOnChange
          },
          busca: {
            id: 'dem-nova--busca',
            status: '',
            newOption: {
              tipo: 'icone',
              icone: { tipo: 'ico-mais' },
              explica: { titulo: '', mensagem: 'Adicionar nova produto' },
              class: [ 'btn', 'btn-primary', 'btn-sm' ],
              onClick: this.demNovaCadastroNovo
            },
            nome: '',
            value: '',
            valueRef: '',
            router: '',
            field: {},
            where: {},
            disabled: false,
            apiEnv: 'busca',
            mostrar: true,
            mensagem: '',
            mensagemTipo: '',
            onChange: this.demNovaCamposOnChange,
            onRealizaBusca: (busca) => {
              // LIMPA O VALOR DO CAMPO SELECIONADO
              this.campos.busca.value = busca

              // LIMPA O VALOR DO CAMPO SELECIONADO
              this.campos.busca.valueRef = ''
            }
          },
          botao: {
            status: '',
            id: 'dem-nova--botao',
            texto: (this.cpntDemanda === 'venda' ? 'Criar Venda' : 'Criar Compra'),
            class: [ 'btn', 'btn-primary' ],
            mostrar: true,
            onClick: () => { this.demNovaCriarVenda() }
          }
        }
      }
    },
    mounted: function () {
      if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(true, null, null, null, null, null, null, false) === false) {
        this.demNovaSetarStatusGeral('bloqueado')
      } else if ((this.cpntDemanda === 'venda' && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 10 ], null, [ 13 ], null, true) === true) || (this.cpntDemanda === 'compra' && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 5 ], null, [ 11 ], null, [ 19 ], null, true) === true) || (this.cpntDemanda === 'despesa' && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 4 ], null, [ 40 ], null, [ 328 ], null, false) === true)) {
        this.demNovaIniciar()
      }
    },
    methods: {
      demNovaIniciar: function () {
        // CHAMA A FUNÇÃO PARA FORÇAR O FECHAMENTO DA TELA
        this.demNovaForcarFecharMenu()

        // VERIFICA A DEMANDA QUE DEVE COLOCAR NO BOTÃO
        switch (this.cpntDemanda) {
          case 'venda':
            this.campos.botao.texto = 'Criar Venda'
            break
          
          case 'compra':
            this.campos.botao.texto = 'Criar Compra'
            break

          case 'despesa':
            this.campos.botao.texto = 'Criar Despesa'
            break
        }

        // VERIFICA O QUE DEVE PROCESSAR
        if ([ '', null, undefined ].indexOf(this.cpntDemanda) === -1 && [ '', null, undefined ].indexOf(this.cpntTipo) === -1 && [ '', null, undefined ].indexOf(this.cpntParamsId) === -1) {
          // SETA O VALOR INICIAL DO CAMPO
          var pco = this.$store.state.configuracoes.venda.ven.cfg_id_pco_status

          // INICIA A CRIAÇÃO DA VENDA
          this.demNovaCriarVenda(this.cpntTipo, this.cpntParamsId, pco)
        } else {
          // SETA O STATUS DA TELA
          this.demNovaSetarStatusGeral('carregando')
  
          // IMPORTA A FUNÇÃO PARA ATUAIZAR OS DADOS DA API
          const FUN_TRATAR_RETONOS_E_CALLBACK = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_RETONOS_E_CALLBACK
  
          // EXECUTA A FUNÇÃO DE CALLBACKS
          FUN_TRATAR_RETONOS_E_CALLBACK(null, {
            demNovaCriarAbas: [ ],
            demNovaBuscarListaProcesso: [ ],
            demNovaFinalizar: [ 'demNovaCriarAbas', 'demNovaBuscarListaProcesso' ]
          },
          {
            demNovaCriarAbas: (chave, callback) => { this.demNovaCriarAbas(() => { callback(chave) } ) },
            demNovaBuscarListaProcesso: (chave, callback) => { this.demNovaBuscarListaProcesso(() => { callback(chave) } ) },
            demNovaFinalizar: (chave, callback) => { this.demNovaFinalizar(() => { callback(chave) } ) },
          })
        }
      },
      demNovaCriarAbas: function (callback = null) {
        // SETA O VALOR INICIAL
        var valor = 'contato'

        // INICIA VARIAVEL DE ABAS
        var vetor = { contato: { chave: 'contato', nome: 'Contato', disabled: false } }

        // VERIFICA AS ABAS DA DEMANDA QUE DEVE CRIAR
        if (this.cpntDemanda === 'venda') {
          // VERIFICA SE TEM OS PACOTE VEICULO
          if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 8 ], null, null, null, null, null, false) === true) {
            vetor.veiculo = { chave: 'veiculo', nome: 'Veículo', disabled: false }
            valor = 'veiculo'
          }
  
          // VERIFICA SE TEM OS PACOTE PET
          if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 28 ], null, null, null, null, null, false) === true) {
            vetor.pet = { chave: 'pet', nome: 'Pet', disabled: false }
            valor = 'pet'
          }
        }

        // SETA AS ABAS QUE DEVE MOSTRAR
        this.abaVet = vetor

        // SETA A ABA INICAL
        this.demNovaOnChangeAba(valor, callback)

        // EXECUTA A FUNÇÃO CALLBACK
        if (callback !== null && typeof callback === 'function') {
          callback()
        }
      },
      demNovaSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demNovaFinalizar: function (callback = null) {
        // SETA O STATUS DA PAGINA
        this.demNovaSetarStatusGeral('')

        // // CHAMA A FUNÇÃO PARA DAR FOCUS NO CAMPO
        // this.demNovaRealizarFocusCampo('busca')

        // EXECUTA A FUNÇÃO CALLBACK
        if (callback !== null && typeof callback === 'function') {
          callback()
        }
      },
      demNovaBuscarListaProcesso: function (callback = null) {
        if (this.cpntDemanda === 'venda' && this.$store.state.pcoAntigo === false && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 11 ], null, null, null, null, null, false) === true) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { id: null, nome: null}, order: { nome: 'asc' } }

          // SETA O WHERE QUE DEVE REALIZAR
          queryGet.where = { f: 'status', o: '=', v: '1' }

          // FAZ A BUSCA NA API
          this.$store.state.comunicaAPI('/con-processo/config/status/get/', 'GET', queryGet, (apiSuccess) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.pco.options = apiSuccess.data

            // SETA O VALOR INICIAL DO CAMPO
            this.campos.pco.value = this.$store.state.configuracoes.venda.ven.cfg_id_pco_status

            // EXECUTA A FUNÇÃO CALLBACK
            if (callback !== null && typeof callback === 'function') {
              callback()
            }
          }, this.demNovaSetarStatusGeral)
        } else {
          // OCULTA O CAMPO QUE NÃO DEVE APRESENTAR
          this.campos.pco.mostrar = false

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          if (callback !== null && typeof callback === 'function') {
            callback()
          }
        }
      },
      demNovaOnChangeAba: function (aba, callback = null) {
        // LIMPA O CAMPO ANTES DE MUDAR DE ABA
        this.campos.busca.value = ''
        this.campos.busca.valueRef = ''

        // QUEBRA A ESTRUTURA DE CALLBACK
        setTimeout(() => {
          // SETA A ABA SELECIONADA
          this.abaVal = aba

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // CHAMA A FUNÇÃO PARA DAR FOCUS NO CAMPO
          this.demNovaRealizarFocusCampo('busca')

          // CHAMA A FUNÇÃO PARA VERIFICA O CAMPO
          setTimeout(() => { this.demNovaTratarAlteracaoCampos(callback) }, 0)
        }, 0)
      },
      demNovaRealizarFocusCampo: function (chave, tentativa = 0) {
        // SETA O FOCUS NO CAMPO
        if (this.$store.state.mobile === false && tentativa <= 10) {
          if ([ '', null, undefined ].indexOf(this.$refs[chave]) === -1 && [ '', null, undefined ].indexOf(this.$refs[chave].cpntRealizarFocus) === -1) {
            this.$refs[chave].cpntRealizarFocus()
          } else {
            setTimeout(() => { this.demNovaRealizarFocusCampo(chave, (tentativa + 1)) }, 250)
          }
        }
      },
      demNovaTratarAlteracaoCampos: function (callback = null) {
        // INICIA A VARIAVEL QUE VAI SETAR OS DADOS
        var nome = ''
        var value = ''
        var valueRef = ''
        var router = ''
        var field = ''
        var where = ''
        var keyMostra = ''
        var novo = ''
        var method = 'GET'
        
        // VERIFICA O TIPO DE INFORMAÇÃO QUE DEVE SER SETADO
        switch (this.abaVal) {
          case 'veiculo':
            nome = 'Digite a placa'

            value = ''
            valueRef = ''

            router = '/veiculo/get'
            method = 'POST'
            field = { id: null, placa: null, id_con: { j: { nome: null } }, id_mod: { j: { nome: null } }, id_mar: { j: { nome: null } }, ref_modelo: { j: { j_modelo: null, id_marca: { j: { j_marca: null } } } } }
            where = { aAnd: [ { f: 'status', m: 'veiculo', o: '=', v: '1' }, { aOr: [ { m: 'vei_mod', o: 's.ft', v: '#BUSCA#' }, { m: 'vei_mar', o: 's.ft', v: '#BUSCA#' }, { m: 'vei_modelo', o: 's.ft', v: '#BUSCA#' }, { m: 'vei_marca', o: 's.ft', v: '#BUSCA#' }, { m: 'contato', o: 's.ft', v: '#BUSCA#' }, { m: 'veiculo', o: 's.ft', v: '#BUSCA#' } ] } ] }
            keyMostra = [ 'id_con_nome', ' (', 'id_mar_nome', ' ', 'id_mod_nome', ' ', 'placa', ')' ],

            novo = 'Adicionar novo veículo'
            break

          case 'pet':
            nome = 'Digite sua pesquisa'

            value = ''
            valueRef = ''

            router = '/pet/get'
            method = 'POST'
            field = { id: null, nome: null, id_con: { j: { nome: null } }, id_pet_subespecie: { j: { j_subespecie: { a: 'id_pet_subespecie_nome' } } } }
            where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { m: 'pet', o: 's.ft', v: '#BUSCA#' } ] }
            keyMostra = [ 'nome', ' | ', 'id_pet_subespecie_nome', ' | ', 'id_con_nome' ]

            novo = 'Adicionar novo pet'
            break
        
          case 'contato':
          default:
            nome = 'Digite sua pesquisa'

            if (this.cpntDemanda === 'venda') {
              value = { id: this.$store.state.contato_pdr.cli, nome: '.CLIENTE PADRÃO', empresa: '', cnpj_cpf: '' }
              valueRef = this.$store.state.contato_pdr.cli
            } else {
              value = { id: this.$store.state.contato_pdr.for, nome: '.FORNECEDOR PADRÃO', empresa: '', cnpj_cpf: '' }
              valueRef = this.$store.state.contato_pdr.for
            }

            router = '/contato/get'
            method = 'POST'
            field = { id: null, nome: null, empresa: null, cnpj_cpf: null }
            where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { m: 'contato', o: 's.ft', v: '#BUSCA#' } ] }
            keyMostra = [ 'nome', ' | ', 'empresa', ' | ', 'cnpj_cpf' ]

            novo = 'Adicionar novo contato'
            break
        }

        // SETA OS VALORES DESEJADOS
        this.campos.busca.nome = nome
        this.campos.busca.value = value
        this.campos.busca.valueRef = valueRef
        this.campos.busca.router = router
        this.campos.busca.method = method
        this.campos.busca.field = field
        this.campos.busca.where = where
        this.campos.busca.keyMostra = keyMostra
        this.campos.busca.newOption.explica.mensagem = novo

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // EXECUTA A FUNÇÃO CALLBACK
        if (callback !== null && typeof callback === 'function') {
          callback()
        }
      },
      demNovaFechar: function (atualizar, id) {
        // EXECUTA A FUNÇÃO RECEBIDA PARA FECHAR
        if (this.cpntFecharFormulario !== null) {
          this.cpntFecharFormulario(atualizar, id)
        }
        
        // VERIFICA SE DEVE MUDAR DE PAGINA
        if (this.cpntRedirecionar === true) {
          if (this.cpntFecharFormulario === null || atualizar === true) {
            switch (this.cpntDemanda + '_' + atualizar) {
              case 'venda_false':
                this.$router.push({ name: 'vendas_gerenciar' })
                break
  
              case 'venda_true':
                // RODA A PAGINA PARA CIMA
                $('html, body').animate({ scrollTop: 0 }, 'slow')

                // ABRE A TELA DA NOVA VENDA
                this.$router.push({ name: 'venda_numero', params: { id: id } })
                break
  
              case 'compra_false':
                this.$router.push({ name: 'compras_gerenciar' })
                break
  
              case 'compra_true':
                // RODA A PAGINA PARA CIMA
                $('html, body').animate({ scrollTop: 0 }, 'slow')

                // ABRE A TELA DA COMPRA VENDA
                this.$router.push({ name: 'compra_numero', params: { id: id } })
                break

              case 'despesa_false':
                this.$router.push({ name: 'despesa_gerencia' })
                break
  
              case 'despesa_true':
                // RODA A PAGINA PARA CIMA
                $('html, body').animate({ scrollTop: 0 }, 'slow')

                // ABRE A TELA DA COMPRA VENDA
                this.$router.push({ name: 'despesa_nova_id', params: { id: id } })
                break
            }
          }
        }
      },
      demNovaCadastroNovo: function (busca) {
        // SETA OS PARAMETROS QUE SERÁ ENVIADO
        var params = { editar: true, id: 0, nome: busca, tpCon: (this.cpntDemanda === 'venda' ? '1' : '2'), cadastroRapido: true }

        // SETA O TIPO DE REGISTRO QUE DEVE ABRIR
        params.tipo = this.abaVal

        // SETA O CALLBACK QUE DEVE EXECUTAR
        params.callback = (atualizar, id, dados) => {
          if (atualizar === true) {
            this.demNovaCamposOnChange(dados, this.campos.busca.id)
          }
        }

        // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params) 
      },
      demNovaCamposOnChange: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTA SENDO ALTERADO
        var index = id.split('--')[1]

        // SETA O VALOR RECEBIDO
        this.campos[index].value = value

        // REMOVE A MENSAGEM DE ERRO
        this.campos[index].mensagem = ''
        this.campos[index].mensagemTipo = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
        
        switch (index) {
          case 'busca':
            // SETA O VALOR RECEBIDO
            this.campos[index].valueRef = value.id

            // SETA O VALOR NO CAMPO
            switch (this.abaVal) {
              case 'veiculo':
                this.campos[index].value = value.placa
                break
              
              default:
                this.campos[index].value = value.nome
                break
            }

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()

            // CHAMA A FUNÇÃO PARA CRIAR A VENDA
            this.demNovaCriarVenda()
            break
        }
      },
      demNovaCamposTravarDestravar: function (valor) {
        // SETA O STATUS PARA AS ABAS
        if ([ '', null, undefined ].indexOf(this.abaVet) === -1 && Object.keys(this.abaVet).length >= 1) {
          for (var indexA in this.abaVet) {
            this.abaVet[indexA].disabled = valor
          }
        }

        // SETA O STATUS DE TODOS OS CAMPOS
        if ([ '', null, undefined ].indexOf(this.campos) === -1 && Object.keys(this.campos).length >= 1) {
          for (var indexC in this.campos) {
            if (indexC !== 'botao') {
              this.campos[indexC].disabled = valor
            }
          }

          // SETA O STATUS DO BOTAO
          if ([ '', null, undefined ].indexOf(this.campos.botao) === -1) {
            this.campos.botao.status = valor === true ? 'carregando' : ''
          }
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demNovaCriarVenda: function (tipo = null, valor, pco = '') {
        // TRAVA TODOS OS CAMPOS
        this.demNovaCamposTravarDestravar(true)
        
        // VERIFICA SE TEM OS PARAMETROS
        if (tipo === null) {
          // SETA O TIPO DE REGISTRO QUE SERÁ UTILIZADO
          tipo = this.abaVal

          // SETA O ID DO CADASTRO SELECIONADO
          valor = this.campos.busca.valueRef

          // SETA O VALOR PARA O CONTROLE DE PROCESSOS
          pco = (this.campos.pco.mostrar === true && [ '', null, undefined ].indexOf(this.campos.pco.value) === -1) ? this.campos.pco.value : ''

          // CHAMA A FUNÇÃO PARA REINICIAR O PROCESSO
          this.demNovaCriarVenda(tipo, valor, pco)
        } else if (this.cpntDemanda === 'despesa') {
          this.demNovaFechar(true, valor)
        } else {
          // INICIA O FORMULARIO PARA ENVIAR PARA API
          var formData = {}
  
          // SETA O VALOR NO CAMPO
          switch (tipo) {
            case 'veiculo':
              formData.id_pacote = '8'
              formData.id = valor
              break

            case 'pet':
              formData.id_pacote = '28'
              formData.id = valor
              break

            case 'contato':
            default:
              formData.id_pacote = '21'
              formData.id = valor
              break
          }
          
          // SETA O VALOR DO CONTROLE DE PROCESSOS
          if ([ '', null, undefined ].indexOf(pco) === -1) {
            formData.id_pco_status = typeof pco === 'object' ? pco.id : pco
          }

          // VERIFICA O TIPO DA DEMANDA A SER CRIADA
          var router = ''
          switch (this.cpntDemanda) {
            case 'venda':
              router = '/venda'
              break

            case 'compra':
              // SETA A ROTA QUE DEVE CHAMAR
              router = '/demanda/dem-compra'

              // SETA O PARAMETRO QUE DEVE USAR
              formData.id_con = formData.id

              // CONVERTE O VALOR EM LOTE
              formData = { lot: [ formData ] }
              break
          }          

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI(router, 'POST', formData, (retorno) => {
            // PEGA O RETORNO RECEBIDO 
            retorno = [ '', null, undefined ].indexOf(retorno.lot) === -1 ? retorno.lot[0] : Object.assign(retorno, { code: '200' })

            // VERIFICA O RESULTADO DA OPERAÇÃO
            switch (retorno.code) {
              case '200':
                // APRESENTA A MENSAGEM DE SUCESSO
                this.$store.state.msgWarn(retorno.message, 'success')

                // PEGA O NUMERO DA REFERENCIA
                var id = retorno.ref.id

                // PROCURA O VALOR DA CHAVE
                if ([ '', null, undefined ].indexOf(retorno.ref.dem_venda) === -1) {
                  id = retorno.ref.dem_venda
                } else if ([ '', null, undefined ].indexOf(retorno.ref.cod_venda) === -1) {
                  id = retorno.ref.cod_venda
                } else if ([ '', null, undefined ].indexOf(retorno.ref.dem_compra) === -1) {
                  id = retorno.ref.dem_compra
                }

                // REALIZA O FECHAMENTO DA TELA
                this.demNovaFechar(true, id)
                break

              default:
                this.demNovaTratarValidacao(retorno.message, retorno.code)
                break
            }
          }, this.demNovaSetarStatusGeral, (apiValid, apiStatus) => { this.demNovaTratarValidacao(apiValid, apiStatus) })
        }
      },
      demNovaTratarValidacao: function (apiValid, apiStatus = 400, callback = null) {
        // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
        const FUN_TRATAR_VALIDACAO_API = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_VALIDACAO_API

        // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
        FUN_TRATAR_VALIDACAO_API(apiValid, apiStatus, this.campos, this).then(() => {
          // TRAVA TODOS OS CAMPOS
          this.demNovaCamposTravarDestravar(false)

          // CHAMA A FUNÇÃO PARA DAR FOCUS NO CAMPO
          this.demNovaRealizarFocusCampo('busca')

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
          
          // EXECUTA O CALLBACK RECEBIDO
          if (callback !== null && typeof callback === 'function') {
            callback()
          }
        })
      },
      demNovaForcarFecharMenu: function (tentativa = 0) {
        if (tentativa <= 10) {
          if (document.getElementsByClassName('app-menu-botoes').length >= 1) {
            // VERIFICA SE O MENU ESTÁ ABERTO
            this.$store.commit('EXECUTE_ATALHO', 'ALT+M')
  
            // REINICIA O PROCESSO
            setTimeout(() => { this.demNovaForcarFecharMenu((tentativa + 1)) }, 200)
          }
        }
      },
      demNovaDisativarBotao: function () {
        // SETA O VALOR PARA O CONTROLE DE PROCESSOS
        var disabled = (this.campos.pco.mostrar === true && [ '', null, undefined ].indexOf(this.campos.pco.value) !== -1)

        // VERIFICA SE O VALOR FOI SELECIONADO
        disabled = disabled === false && [ '', null, undefined ].indexOf(this.campos.busca.valueRef) !== -1
        
        // RETORNADO O VALOR CALCULADO
        return disabled
      }
    }
  }
</script>
